import styled from 'styled-components';

const ClickableText = styled.span`
    color: #00a3e0;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 30em;
    :hover {
        cursor: pointer;
    }
`;

export default ClickableText;
